// Client-side mirror of the backend password policy (utils/passwordPolicy.js on zed backend).
// The backend is authoritative; this exists so the first submit passes.

export const PASSWORD_RULES = [
    { key: 'length', label: 'At least 8 characters', test: (p) => p.length >= 8 && p.length <= 128 },
    { key: 'upper', label: 'An uppercase letter', test: (p) => /[A-Z]/.test(p) },
    { key: 'lower', label: 'A lowercase letter', test: (p) => /[a-z]/.test(p) },
    { key: 'digit', label: 'A number', test: (p) => /\d/.test(p) },
    { key: 'special', label: 'A special character (e.g. ! @ #)', test: (p) => /[^A-Za-z0-9]/.test(p) },
    { key: 'spaces', label: 'No spaces', test: (p) => p.length > 0 && !/\s/.test(p) },
];

export const checkPasswordRules = (password = '') =>
    PASSWORD_RULES.map((rule) => ({ ...rule, passed: rule.test(String(password)) }));

export const passwordMeetsPolicy = (password = '') =>
    PASSWORD_RULES.every((rule) => rule.test(String(password)));
